import { Component, HostListener, Input, ViewChild } from "@angular/core";
import { DrProfile } from "src/app/shared/models/order.model";
import { AppState } from "src/app/shared/redux/store";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { SignaturePadComponent, SignaturePadOptions } from "src/app/shared/components/ui/signature-pad";

@Component({
  selector: "edit-profile-sign",
  templateUrl: "./edit-profile-sign.component.html",
  styleUrls: ["./edit-profile-sign.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SignaturePadComponent,
  ],
  standalone: true,
})
export class EditProfileSignComponent {
  @ViewChild("signature")
  public signaturePad: SignaturePadComponent;

  @Input() profile: DrProfile;

  signaturePadOptions: SignaturePadOptions = {
    minWidth: 1.5,
    maxWidth: 1.5,
    canvasHeight: 200,
    canvasWidth: 600,
    backgroundColor: "rgb(255,255,255)",
  };

  sizeRatio = 5;

  @HostListener("window:resize", ["$event"])
  onResize(event?: Event) {
    this.initSize();
  }

  constructor() { }

  ngAfterViewInit(): void {
    // Small delay to ensure the canvas is properly initialized
    setTimeout(() => {
      this.initSize();
    }, 100);
  }

  initSize() {
    let width = document.getElementById("signContainer")?.clientWidth || 600;
    let height = width / this.sizeRatio;
    this.signaturePad.set("canvasWidth", width);
    this.signaturePad.set("canvasHeight", height);

    if (this.profile.signDataUrl) {
      this.signaturePad.fromDataURL(this.profile.signDataUrl, {
        width: width,
        height: height,
      });
    }
  }

  drawComplete(event: MouseEvent | Touch) {
    this.profile.signDataUrl = this.signaturePad.toDataURL();
    console.log(this.profile.signDataUrl);
  }

  drawStart(event: MouseEvent | Touch) { }

  clear() {
    this.signaturePad?.clear();
  }

  save() { }
}
